import {GenericService, ResultType} from '@/shared/xhttp';
import {Commande, Vente} from '@/models';

export class CommandeService extends GenericService<Commande> {

	public getCommandes(): Promise<ResultType<Commande>> {
		return super.getC(`/active`,999999);
	}

}
